module.exports = __webpack_public_path__ + "img/insuranceBg.2f3eabc2.png";